import { Button, Space, notification, List, Tag, Card, Form, Select, Divider, Alert } from "antd";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import ModalCreated from "./components/ModalCreated";
import { langNotifications, roles } from "constants/index";
import { getUser, handleUploadImage } from "utils/index";
import { EyeOutlined, MessageOutlined, PaperClipOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import userApi from "api/user";
import notificationApi from "api/notification";
import ModalDetail from "./components/ModalDetail";
import moment from "moment";
import imageApi from "api/image";
import ModalDelete from "./components/ModalDelete";
import { rolesNotShowAction, rolesSendNoti } from "./roles";
const cx = classNames.bind(style);

export default function Notification() {
  const [api, contextHolder] = notification.useNotification();

  const { t } = useTranslation()

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({ message, description });
  };

  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shops, setShops] = useState([]);
  const [selected, setSelected] = useState(null);
  const [listNotification, setListNotification] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [selectedLang, setSelectedLang] = useState('de');

  const onOpenModalDetail = (item) => {
    setOpenModalDetail(true)
    setSelected(item)
  }

  const onCloseModalDetail = () => {
    setOpenModalDetail(false)
    setSelected(null)
  }

  const openModalEdit = (item) => {
    setOpenModalCreate(true)
    setSelected(item)
  }

  const closeEditModal = () => {
    setOpenModalCreate(false)
    setSelected(null)
  }

  const onOpenModalDelete = (item) => {
    setOpenModalDelete(true)
    setSelected(item)
  }

  const onCloseModalDelete = () => {
    setOpenModalDelete(false)
    setSelected(null)
  }

  const fetchNotification = async (current = pagination.current) => {
    try {
      setLoading(true)
      const res = await notificationApi.getAll({
        current,
        limit: pagination.pageSize,
      });
      setListNotification(res.data);
      setPagination({
        current,
        pageSize: pagination.pageSize,
        total: res.total,
      });
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const renderTypeFromUser = (role) => {
    switch (role) {
      case roles.qs:
        return 'info';
      case roles.regionManager:
      case roles.viceRegionManager:
        return 'error';
      default:
        return 'default';
    }
  }

  const getShopManager = async () => {
    try {
      setLoading(true)
      const res = await userApi.getAllShopManager();
      setShops(res.users.filter(item => item.shops.length > 0).sort((a, b) => a.shops[0].shop.shop_code - b.shops[0].shop.shop_code));
    } catch (error) {
      console.log("🚀 ~ error:", error)
    } finally {
      setLoading(false)
    }
  }

  const onSubmitSendNoti = async (values) => {
    try {
      setLoading(true)
      let uploadedImages = [];
      if (values.attachments && values.attachments.length > 0) {
        // find attachments need to delete
       if (selected) {
          const attachmentsNeedDelete = selected.attachments.filter(file => !values.attachments.some(item => item.uid === file._id));
          if (attachmentsNeedDelete.length > 0) {
            const res = await Promise.all(attachmentsNeedDelete.map(file => imageApi.deleteImage(file.fileId, {
              isRaw: file.type === 'file',
            })));
            if (res.some(item => !item?.success)) {
              openNotificationWithIcon('error', t('error'), t('uploadFileFail'))
              return;
            }
          }
       }

        // upload new images
        uploadedImages = await Promise.all( values.attachments.filter(file => !file.isOld).map(file => handleUploadImage(file)));
        if (uploadedImages.some(item => !item?.success)) {
          openNotificationWithIcon('error', t('error'), t('uploadFileFail'))
        }
      }

      if (selected) {
        await notificationApi.update(selected._id, {
          content: values.content,
          attachments: [
            ...uploadedImages.map(item => ({
              fileId: item.result.public_id,
              fileUrl: item.result.url,
              type: ['png', 'jpg', 'jpeg'].includes(item.result.format) ? 'image' : 'file',
            })),
            ...selected.attachments.filter(file => values.attachments.some(item => item.uid === file._id)),
          ],
        });
      } else {
        await notificationApi.send({
          listShopUser: values.type == 1 ? shops.map(shop => shop._id) : values.toUser.map(shop => shops.find(item => item.shops[0].shop.shop_code === shop)._id),
          content: values.content,
          attachments: uploadedImages.map(item => ({
            fileId: item.result.public_id,
            fileUrl: item.result.url,
            type: ['png', 'jpg', 'jpeg'].includes(item.result.format) ? 'image' : 'file',
          })),
        });
      }
      openNotificationWithIcon('success', t('notification'), t('success'))
      setOpenModalCreate(false)
      fetchNotification();
    } catch (error) {
      openNotificationWithIcon('error', t('error'), error?.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  const onDelete = async () => {
    try {
      setLoading(true)
      if (selected.attachments.length > 0) {
        const res = await Promise.all(selected.attachments.map(file => imageApi.deleteImage(file.fileId, {
          isRaw: file.type === 'file',
        })));
        if (res.some(item => !item?.success)) {
          openNotificationWithIcon('error', t('error'), t('hasError'))
          return;
        }
      }

      const res = await notificationApi.delete(selected._id);
      if (res.success) {
        openNotificationWithIcon('success', t('notification'), t('success'))
        fetchNotification()
        onCloseModalDelete()
      }
    } catch (error) {
      openNotificationWithIcon('error', t('error'), error?.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getShopManager()
    fetchNotification();
  }, []);

  return (
    <div className={cx("page-shop")}>
      {contextHolder}
      <div className={cx("title")}>
        <p>{t('notification')}</p>
        {
          (rolesSendNoti.includes(+getUser().role)) && (
            <Button size="large" onClick={() => setOpenModalCreate(true)} icon={<MessageOutlined />}>
              {t('sendNotification')}
            </Button>
        )}
      </div>
      <Form.Item label={t('language')}>
        <Select
          value={selectedLang}
          size='large'
          options={langNotifications.map(lang => ({
            ...lang,
            label: t(lang.label),
          }))}
          style={{ width: '300px' }}
          onChange={(value) => setSelectedLang(value)}
        />
      </Form.Item>
      <Divider />
      <Card>
        <List
          loading={loading}
          itemLayout="vertical"
          size="large"
          pagination={{
            onChange: (page) => {
              fetchNotification(page);
            },
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          dataSource={listNotification}
          renderItem={(item) => (
            <List.Item
              key={item.title}
              actions={[
                // <Button icon={<EyeOutlined />} onClick={() => onOpenModalDetail(item)} />,
                !rolesNotShowAction.includes(+getUser().role) ? <Button icon={<EditOutlined />} onClick={() => openModalEdit(item)} /> : undefined,
                !rolesNotShowAction.includes(+getUser().role) ? <Button icon={<DeleteOutlined />} onClick={() => onOpenModalDelete(item)} /> : undefined,
              ].filter(item => item)}
            >
              <List.Item.Meta
                title={(
                  <Space>
                    <Alert message={item.fromUser.name} type={renderTypeFromUser(item.fromUser.role)} />
                    <span>
                      {
                        !rolesNotShowAction.includes(+getUser().role) || 
                        item.toUser.find(shop => shop.user._id === getUser()._id)?.readAt ? 
                          "" : <Tag color="green">{t('new')}</Tag>
                      }
                    </span>
                  </Space>
                )}
                description={(
                <Space direction="vertical">
                  <span>{t('sendTo')}:&nbsp;
                    {
                      item.toUser
                        .filter(
                          shop => rolesSendNoti.includes(+getUser().role) || shop.user._id === getUser()._id
                        )
                        .map(shop => (
                          <Tag key={shop._id} color="blue">{shop.user.shops[0].shop.shop_code}</Tag>
                        ))
                    }
                  </span>
                  <span>{t('sendAt')}: {moment(item.createdAt).format('YYYY/MM/DD HH:mm:ss')}</span>
                </Space>
              )}
              />
              <span className={cx('noti-content')}>
                {item.content.find(content => content.lang == selectedLang)?.text}
              </span>
              {
                item.attachments.length > 0 && (
                  <>
                    <Divider />
                    <Form layout="vertical">
                      <Form.Item
                        label={t('attachments')}
                      >
                        <Space direction="vertical">
                            {item?.attachments.map((attachment, index) => (
                              <Space key={index}>
                                <PaperClipOutlined />
                                <a href={attachment.fileUrl} target="_blank" rel="noreferrer">{`File ${index + 1}`}</a>
                              </Space>
                            ))}
                        </Space>
                      </Form.Item>
                    </Form>
                  </>
                )
              }
            </List.Item>
          )}
        />
      </Card>
      <ModalCreated
        openModal={openModalCreate}
        onCancel={closeEditModal}
        onSubmit={onSubmitSendNoti}
        shops={shops}
        loading={loading}
        selected={selected}
      />
      <ModalDetail
        lang={selectedLang}
        openModal={openModalDetail}
        onCancel={onCloseModalDetail}
        data={selected}
        loading={loading}
      />
      <ModalDelete open={openModalDelete} onCancel={onCloseModalDelete} onDelete={onDelete} loading={loading} />
    </div>
  );
}
